import { UPDATE_USER_PASSWORD } from "./gql/UpdateUser";

import {
  required,
  sameAs,
  minLength,
  maxLength
} from "vuelidate/lib/validators";

export default {
  name: "user_password_control",

  data() {
    return {
      isShowPasswordForm: false,
      submitPasswordLoading: false,

      password: "",
      newPassword: "",
      confirmNewPassword: ""
    };
  },

  props: [],

  validations() {
    let params = {
      password: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(16)
      },
      newPassword: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(16)
      },
      confirmNewPassword: {
        sameAsPassword: sameAs("newPassword")
      }
    };

    return params;
  },

  mounted: function() {},

  methods: {
    editPassword() {
      this.isShowPasswordForm = true;
    },

    hidePasswordForm() {
      this.isShowPasswordForm = false;
    },

    submitPasswordForm() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.submitPasswordLoading = true;

        this.$apollo
          .mutate({
            mutation: UPDATE_USER_PASSWORD,
            variables: {
              currentPassword: this.password,
              password: this.newPassword,
              passwordConfirmation: this.confirmNewPassword
            }
          })
          .then(({ data: { updateUser: { accessToken } } }) => {
            if (typeof localStorage !== "undefined" && accessToken) {
              localStorage.setItem("AUTH_TOKEN", accessToken);
            }
            this.isShowPasswordForm = false;
            this.password = "";
            this.newPassword = "";
            this.confirmNewPassword = "";
          })
          .catch(mutationError => {
            const errors = mutationError.graphQLErrors;

            for (let error in errors) {
              this.$toasted.error(errors[error].message);
            }
          })
          .finally(() => {
            this.submitPasswordLoading = false;
          });
      }
    }
  },

  components: {}
};
